import { PlusCircleTwoTone } from "@ant-design/icons";
import { Button, Card, Form, notification, Upload } from "antd";
import axios from "axios";
import React, { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { getUserRole } from "../../services/util";
import CustomHeader from "../common/Header";

const instance = axios.create({
    baseURL:
        "https://splnleus8b.execute-api.ap-south-1.amazonaws.com/dev/tti-documents",
});

function BuildUploader() {
    const userRole = getUserRole();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    useEffect(() => {
        if (userRole !== "External Vendor") {
            navigate("/404");
            return null;
        }
    }, []);

    async function handleSubmit(values) {
        const formData = new FormData();
        formData.append("file", values.file.file, values.file.file.name);
        instance
            .put(`/${values.file.file.name}`, formData, {
                headers: { "content-type": "multipart/form-data" },
            })
            .then((response) => {
                if (response.status == 200) {
                    notification["info"]({ message: "Upload Successful..!" });
                    form.resetFields();
                }
            });
    }

    return (
        <Card className="dashboard-container">
            <CustomHeader />
            <div style={{ display: "flex", justifyContent: "center" }}>
                <Card
                    className="box-shadow margin-10"
                    style={{ width: "40vw" }}
                    bodyStyle={{
                        backgroundColor: "#8080808f",
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <Form onFinish={handleSubmit} form={form}>
                            <Form.Item
                                name="file"
                                valuePropName="file"
                                rules={[
                                    {
                                        required: true,
                                        message: "Tag list is required",
                                    },
                                ]}
                            >
                                <Upload
                                    beforeUpload={() => false}
                                    maxCount={1}
                                    listType="picture-card"
                                    accept=".msi,.bin"
                                >
                                    <PlusCircleTwoTone />
                                </Upload>
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="margin-top-10"
                                >
                                    Submit
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Card>
            </div>
        </Card>
    );
}

export default BuildUploader;
